// utils/dateUtils.js
import moment from "jalali-moment";
import "moment/locale/fa";
import dayjs from "dayjs";

/**
 * تبدیل هر نوع تاریخ به رشته شمسی (jYYYY-jMM-jDD)
 */
export const toJalaliString = (dateInput) => {
  if (!dateInput && dateInput !== 0) {
    const today = moment().format("jYYYY-jMM-jDD");
    return today;
  }
  
  try {
    // اگر moment object است
    if (dateInput._isAMomentObject) {
      return dateInput.format("jYYYY-jMM-jDD");
    }
    
    // اگر dayjs object است
    if (dateInput.$isDayjsObject) {
      return dayjs(dateInput).format("jYYYY-jMM-jDD");
    }
    
    // اگر Date object است
    if (dateInput instanceof Date) {
      if (isNaN(dateInput.getTime())) {
        return moment().format("jYYYY-jMM-jDD");
      }
      return moment(dateInput).format("jYYYY-jMM-jDD");
    }
    
    // اگر string است
    if (typeof dateInput === 'string') {
      if (dateInput === 'Invalid date') {
        return moment().format("jYYYY-jMM-jDD");
      }
      
      // اگر رشته شمسی است
      if (dateInput.includes('-')) {
        const yearPart = dateInput.split('-')[0];
        if (yearPart.length === 4) {
          // سال 4 رقمی
          if (parseInt(yearPart) < 1500) {
            // شمسی
            const m = moment(dateInput, 'jYYYY-jMM-jDD', true);
            return m.isValid() ? dateInput : moment().format("jYYYY-jMM-jDD");
          } else {
            // میلادی - تبدیل به شمسی
            const m = moment(dateInput, 'YYYY-MM-DD', true);
            return m.isValid() ? m.format("jYYYY-jMM-jDD") : moment().format("jYYYY-jMM-jDD");
          }
        }
      }
      
      // امتحان parse کردن
      const m = moment(dateInput);
      return m.isValid() ? m.format("jYYYY-jMM-jDD") : moment().format("jYYYY-jMM-jDD");
    }
    
    // اگر عدد است (timestamp)
    if (typeof dateInput === 'number') {
      const m = moment(dateInput);
      return m.isValid() ? m.format("jYYYY-jMM-jDD") : moment().format("jYYYY-jMM-jDD");
    }
  } catch (error) {
    console.error("Error in toJalaliString:", error);
  }
  
  return moment().format("jYYYY-jMM-jDD");
};

/**
 * تبدیل به رشته میلادی برای API (YYYY-MM-DD)
 */
export const toGregorianAPIString = (dateInput) => {
  const jalaliString = toJalaliString(dateInput);
  return moment(jalaliString, 'jYYYY-jMM-jDD').format("YYYY-MM-DD");
};

/**
 * تبدیل به moment object jalali
 */
export const toJalaliMoment = (dateInput) => {
  const jalaliString = toJalaliString(dateInput);
  return moment(jalaliString, 'jYYYY-jMM-jDD');
};

/**
 * ایجاد تاریخ امروز به صورت [شمسی, شمسی]
 */
export const getTodayRange = () => {
  const today = moment().format("jYYYY-jMM-jDD");
  return [today, today];
};

/**
 * بررسی معتبر بودن تاریخ
 */
export const isValidDate = (dateInput) => {
  if (!dateInput && dateInput !== 0) return false;
  
  try {
    const str = toJalaliString(dateInput);
    return moment(str, 'jYYYY-jMM-jDD', true).isValid();
  } catch {
    return false;
  }
};